<template>
  <div class="not_found_container">
      <Header class="not_found_header">
        <div class="logo" />
      </Header>

      <Content>
        <router-link to="/login">

        <div class="not_found_bg"></div>
        </router-link>
      </Content>

      <Footer class="not_found_footer">{{copyright}}</Footer>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapMutations } = createNamespacedHelpers('user')
import { Layout} from 'ant-design-vue'
const { Header,Content, Footer } = Layout
import './index.less'
export default {
  data () {
    return {
       copyright:""
    }
  },
  created(){
    this.getCopyright()
  },
  methods:{
       ...mapActions(['getFooterCopyright']),
     async getCopyright(){
       let res = await this.getFooterCopyright();
      this.copyright=res
    },
  },
  components:{
    Header,
    Content,
    Footer
  }
}
</script>

<style lang="less" scoped>
.not_found_container{

}
</style>
